import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  WifiIcon, 
  ExclamationTriangleIcon,
  ArrowPathIcon 
} from '@heroicons/react/24/outline';
import { useWebSocket } from '../../hooks/useWebSocket';

const ConnectionStatus: React.FC = () => {
  const { connectionStatus, isConnected } = useWebSocket();

  if (isConnected) return null; // Don't show when connected

  const getStatusConfig = () => {
    switch (connectionStatus) {
      case 'connecting':
        return {
          icon: ArrowPathIcon,
          message: 'Connecting...',
          className: 'bg-yellow-50 border-yellow-200 text-yellow-800',
          iconClassName: 'text-yellow-600 animate-spin'
        };
      case 'reconnecting':
        return {
          icon: ArrowPathIcon,
          message: 'Reconnecting...',
          className: 'bg-blue-50 border-blue-200 text-blue-800',
          iconClassName: 'text-blue-600 animate-spin'
        };
      // case 'disconnected':
      //   return {
      //     icon: ExclamationTriangleIcon,
      //     message: 'Connection lost. Some features may not work.',
      //     className: 'bg-red-50 border-red-200 text-red-800',
      //     iconClassName: 'text-red-600'
      //   };
      default:
        return null;
    }
  };

  const config = getStatusConfig();
  if (!config) return null;

  const IconComponent = config.icon;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -50 }}
        className={`fixed top-0 left-0 right-0 z-50 p-3 border-b ${config.className}`}
      >
        <div className="max-w-7xl mx-auto flex items-center justify-center space-x-2">
          <IconComponent className={`h-4 w-4 ${config.iconClassName}`} />
          <span className="text-sm font-medium">{config.message}</span>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ConnectionStatus;
